import { render, staticRenderFns } from "./Payfast.vue?vue&type=template&id=2c3a5610&scoped=true"
import script from "./Payfast.vue?vue&type=script&lang=js"
export * from "./Payfast.vue?vue&type=script&lang=js"
import style0 from "./Payfast.vue?vue&type=style&index=0&id=2c3a5610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3a5610",
  null
  
)

export default component.exports